<template>
  <div id="menuAnalisys"><!-- menu-log -->
    <div class="container menu-order manu-analisys">
      <div class="container">
        <h3 class="title-order">
          Zamawianie analizy
        </h3>
      </div>
      <nav class="navbar-expand-md" id="menu-analisys">
        <div class="container">
          <div class=" navbar-collapse" id="logMenu">
            <ul class="navbar-nav mx-auto w-100 nav-justified">
              <li :class="[active_page == 2 ? 'active':'','nav-item']">
                <a class="navbar-brand" href="#">
                  <img src="../assets/img/collection-set-icon.png" class="d-inline-block" alt="">
                  {{$t('breadcrumb_analysis_order.collection_set')}}
                  <div class="order-navbar-brand-mobile">1 / 5</div>
                </a>
              </li>
              <li :class="[active_page == 3 ? 'active':'','nav-item']">
                <a class="navbar-brand" href="#">
                  <img src="../assets/img/storage-option-icon.png" class="d-inline-block" alt="">
                  {{$t('breadcrumb_analysis_order.data_carrier')}}
                  <div class="order-navbar-brand-mobile">2 / 5</div>
                </a>
              </li>
              <li :class="[active_page == 4 ? 'active':'','nav-item']">
                <a class="navbar-brand" href="#">
                  <img src="../assets/img/med-nurse-icon.png" class="d-inline-block" alt="">
                  {{$t('breadcrumb_analysis_order.consultation')}}
                  <div class="order-navbar-brand-mobile">3 / 5</div>
                </a>
              </li>
              <li :class="[active_page == 5 ? 'active':'','nav-item']">
                <a class="navbar-brand" href="#">
                  <img src="../assets/img/summary-icon.png" class="d-inline-block" alt="">
                  {{$t('breadcrumb_analysis_order.summary')}}
                  <div class="order-navbar-brand-mobile">4 / 5</div>
                </a>
              </li>
              <li :class="[active_page == 6 ? 'active':'','nav-item']">
                <a class="navbar-brand" href="#">
                  <img src="../assets/img/payment-icon.png" class="d-inline-block" alt="">
                  {{$t('breadcrumb_analysis_order.payment')}}
                  <div class="order-navbar-brand-mobile">5 / 5</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Breadcrumb",
    props: ['active_page'],
    data: function () {
      return {}
    }
  }
</script>

<style scoped>
  .underlined {
    text-decoration: underline !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue